import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import WordCounter from './components/WordCounter';
import JsonFormatter from './components/JsonFormatter';
import ImageResizer from './components/ImageResizer';
import PdfConverter from './components/PdfConverter';
import Sidebar from './components/Sidebar';
import YouTubeDownloader from './components/YouTubeDownloader';
import FileConverter from './components/FileConverter';
import LandingPage from './components/LandingPage';
import TextCaseConverter from './components/TextCaseConverter';
import ApiKeyGenerator from './components/ApiKeyGenerator';

function App() {
  // Initialize Google AdSense
  useEffect(() => {
    try {
      // @ts-ignore
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (error) {
      console.error('AdSense error:', error);
    }
  }, []);

  return (
    <Router>
      <div className="App">
        <header className="header">
          <h1 className="text-xl">UsaAí</h1>
          {/* Botão de modo claro/escuro */}
        </header>
        <div className="flex">
          <Sidebar />
          <main className="main-content" style={{ flex: 1, padding: '20px' }}>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/word-counter" element={<WordCounter />} />
              <Route path="/json-formatter" element={<JsonFormatter />} />
              <Route path="/image-resizer" element={<ImageResizer />} />
              <Route path="/pdf-converter" element={<PdfConverter />} />
              <Route path="/youtube-downloader" element={<YouTubeDownloader />} />
              <Route path="/file-converter" element={<FileConverter />} />
              <Route path="/text-case-converter" element={<TextCaseConverter />} />
              <Route path="/api-key-generator" element={<ApiKeyGenerator />} />
            </Routes>
          </main>
        </div>
      </div>
    </Router>
  );
}

export default App;
